import { render, staticRenderFns } from "./UserProductTable.vue?vue&type=template&id=0eb3e973&scoped=true&"
import script from "./UserProductTable.vue?vue&type=script&lang=js&"
export * from "./UserProductTable.vue?vue&type=script&lang=js&"
import style0 from "./UserProductTable.vue?vue&type=style&index=0&id=0eb3e973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb3e973",
  null
  
)

export default component.exports